import { render, staticRenderFns } from "./ventasdeldia.vue?vue&type=template&id=a1ff4862"
import script from "./ventasdeldia.vue?vue&type=script&lang=js"
export * from "./ventasdeldia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports